/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Filter_All_TypesInputs */

const vi_customer_debt_filter_all_types = /** @type {(inputs: Customer_Debt_Filter_All_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả loại`)
};

/**

* @param {Customer_Debt_Filter_All_TypesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_filter_all_types = /** @type {((inputs?: Customer_Debt_Filter_All_TypesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Filter_All_TypesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_filter_all_types(inputs)
});